import { render, staticRenderFns } from "./PlanejamentoDeAulas.vue?vue&type=template&id=428a927a&scoped=true"
import script from "./PlanejamentoDeAulas.vue?vue&type=script&lang=js"
export * from "./PlanejamentoDeAulas.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoDeAulas.vue?vue&type=style&index=0&id=428a927a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428a927a",
  null
  
)

export default component.exports